const clientSideValidation = require('app_byl_core/components/clientSideValidation');
const { onOnce } = require('app_byl_core/common/utils/domEvents');
const Rellax = require('rellax');

const HIDDEN_CLASS = 'd-none';
const INVALID_CLASS = 'is-invalid';
const FORM_NAME = 'dwfrm_mothersDay';
const SELECTED_CARD_IMAGE_REGEX = /\d\.jpg/g;
const DEFAULT_HEADER_HEIGHT = 40;

/**
 * It removes the `invalid` class from all elements in the form that have it
 * @param {HTMLFormElement} form - The form element that you want to clear errors from.
 */
function clearFormErrors(form) {
    const errors = form.querySelectorAll(`.${INVALID_CLASS}`);
    errors.forEach((error) => error.classList.remove(INVALID_CLASS));
}

/**
 * It adds an event listener to the form that calls the validateForm function when the form is
 * submitted
 */
function initFormValidation() {
    const form = document.getElementById(FORM_NAME);
    form.addEventListener('submit', validateForm);
}

/**
 * It finds the first invalid input in the form, gets its position relative to the top of the page, and
 * scrolls to that position minus the height of the header
 * @param {HTMLFormElement} form - The form element that you want to validate.
 */
function scrollToError(form) {
    const error = form.querySelector(`.${INVALID_CLASS}`);
    if (error) {
        const { top } = error.getBoundingClientRect();
        const headerHeight =
            parseInt(
                document.documentElement.style
                    .getPropertyValue('--header-total-height')
                    .slice(0, -2),
                10
            ) || DEFAULT_HEADER_HEIGHT;
        window.scrollTo(0, top + window.scrollY - headerHeight);
    }
}

/**
 * It takes the form data, sends it to the server and redirects to a success or
 * error page
 * @param {HTMLFormElement} form - the form element
 * @param {FormData} formData - the data from the form
 */
function submitMothersDayForm(form, formData) {
    const url = form.getAttribute('action');

    const body = new URLSearchParams(formData);

    fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body,
    })
        .then((response) => {
            if (!response.ok) {
                // eslint-disable-next-line no-console
                console.warn('Message:', response.message);
            } else {
                document
                    .querySelector('.mothers-day-landing')
                    .classList.add(HIDDEN_CLASS);
                window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
                document
                    .querySelector('.mothers-day-landing__success')
                    .classList.remove(HIDDEN_CLASS);
                // Send submit info to analytics
                const submitEvent = new CustomEvent('mothers-day:submit');
                document.dispatchEvent(submitEvent);
            }
        })
        .catch((error) => {
            // eslint-disable-next-line no-console
            console.error('Error:', error);
        })
        .finally(() => {
            grecaptcha.reset();
        });
}

/**
 * It validates the form data, and if it's valid, it submits the form
 * @param {Event} e - the event object
 */
function validateForm(e) {
    e.preventDefault();
    const form = e.target;
    const formData = new FormData(form);
    const validationCallbacks = validateRecaptcha;

    clearFormErrors(form);

    let valid = clientSideValidation.functions.validateFormatData(form);

    if (valid) valid = validationCallbacks.call(null, formData);

    if (valid) {
        submitMothersDayForm(form, formData);
    } else {
        scrollToError(form);
    }
}

function validateRecaptcha() {
    const hiddenRecaptcha = document.querySelector('.hiddenRecaptcha');
    if (hiddenRecaptcha.value !== '') {
        return true;
    }

    grecaptcha.execute();
    return false;
}

function handleSelectedCardChange(e) {
    const downloadLink = document
        .querySelector('.mothers-day-landing-form__download-link')
        .getAttribute('href');
    const newLink = downloadLink.replace(
        SELECTED_CARD_IMAGE_REGEX,
        `${e.target.value}.jpg`
    );
    document
        .querySelector('.mothers-day-landing-form__download-link')
        .setAttribute('href', newLink);
}

function closeNewsletterFooterSection() {
    const newsletterModalFooter = document.querySelector('.footer__newsletter');
    newsletterModalFooter?.classList.remove('interaction-active');
    newsletterModalFooter
        ?.querySelector('.newsletter-modal-container')
        ?.classList.remove('interaction-active');
}

/**
 * When the page loads, initialize the form validation and the repeater.
 */
function init() {
    closeNewsletterFooterSection();
    // eslint-disable-next-line no-unused-vars
    const rellax = new Rellax('.rellax');
    initFormValidation();
    document
        .querySelectorAll('.mothers-day-landing-form__radio')
        .forEach((el) =>
            el.addEventListener('change', handleSelectedCardChange)
        );
}

init();

onOnce(window, 'beforeunload', () => {
    const form = document.getElementById(FORM_NAME);
    form.removeEventListener('submit', validateForm);
    document
        .querySelectorAll('.mothers-day-landing-form__radio')
        .forEach((el) =>
            el.removeEventListener('change', handleSelectedCardChange)
        );
});
